import { ref } from 'vue';
import cookies from 'vue-cookies';
import { setFilial } from '@/modules/configuracoes/filial/store';
import { guidUtil } from '@/utils';
import LoginService from './service';

const user = ref(null);
const filial = ref(null);

function setUserWithFilial(value) {
  user.value = value;
  setFilial(value.filialSelecionada);
}

function setFuncionario(value) {
  user.value = value;
}

function setCookie(key, value, validade) {
  const urlApplication = key === 'PublicToken' ? 'vr.app.br' : import.meta.env.VITE_COOKIE_URL;
  const pathApplication = '/';
  const diasValidadeCookie = validade || '6d';
  cookies.set(key, value, diasValidadeCookie, pathApplication, urlApplication);
}

function logoOutUser() {
  const publicToken = cookies.get('PublicToken');
  LoginService.deletePublicToken(publicToken);
  setCookie('PublicToken', null, '0s');
  setCookie('Filial', null, '0s');
  window.location.href = 'https://vr.app.br/';
}

function funcionarioDefault() {
  return {
    ide: guidUtil.empty,
    codigo: 0,
    nome: '',
    apelido: '',
    senha: '',
    email: '',
    cpf: '',
    inativo: false,
    theme: 0,
    privateTokenETradeWeb: guidUtil.empty,
    comissaoVenda: 0,
    comissaoServico: 0,
    descontoMaximo: 0,
    caixaPadrao: 0,
    entregador: false,
    veiculo__Ide: guidUtil.empty,
    caixa__Ide: guidUtil.empty,
    permissaoGrupo__Ide: guidUtil.empty,
    garcom: false,
  };
}

const props = ref({
  search: '',
  isPreviousPageDisabled: false,
  isNextPageDisabled: false,
  take: 10,
  skip: 0,
  tabelaPreco: '',
  tableData: {
    data: {
      ide: guidUtil.empty,
      codigo: '',
      nome: '',
      fantasia: '',
      cnpj: '',
      fone1: '',
      fone2: '',
    },
  },
  funcionario: funcionarioDefault(),
});

function initValuesFuncionario() {
  props.value.funcionario = funcionarioDefault();
}

function fillFuncionario(value) {
  props.value.funcionario = value;
}

export { user, filial, LoginService, logoOutUser, setCookie, setUserWithFilial, setFuncionario, props, fillFuncionario, initValuesFuncionario };
